/* projects/common-module/src/lib/app-components/select-language/select-language.component.scss */
mat-form-field {
  width: 100%;
}
/*# sourceMappingURL=select-language.component.css.map */
